import { Fragment, ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

const Templates = (): ReactElement => {
  return (
    <Fragment>
      <Outlet />
    </Fragment>
  );
};
export default Templates;
